import React from 'react';
import {
  Box, Divider, ListItemButton
} from '@mui/material';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { BodyRegular, BodyMedium } from 'components/common_v2/typography';
import { UnreadBadge } from '../../styled';

export const NotificationRow = ({
  message, createdAt, read, onClick
}) => {
  const createdAtDate = DateTime.fromISO(createdAt);

  return (
    <ListItemButton dense disableGutters divider onClick={onClick} data-test-id="notifications__notification-content">
      <Box display="flex" p={2} alignItems="center" flexDirection="row" gap={2}>
        <UnreadBadge className={serializeClasses([read && 'read'])} />
        <Box display="flex" flexDirection="column">
          <BodyMedium className={serializeClasses([!read && 'bold'])}>
            {message}
          </BodyMedium>
          <BodyRegular className="info">
            {createdAtDate.toRelative({ round: true })}
          </BodyRegular>
        </Box>
      </Box>
      <Divider />
    </ListItemButton>
  );
};

NotificationRow.propTypes = {
  message: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  read: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
